import IntegrationsPageContent from '@/components/IntegrationsPage'

export default function IntegrationsPage() {
  return <IntegrationsPageContent />
}

